import { render, staticRenderFns } from "./asistente-widget.vue?vue&type=template&id=5106847d&scoped=true&"
import script from "./asistente-widget.vue?vue&type=script&lang=js&"
export * from "./asistente-widget.vue?vue&type=script&lang=js&"
import style0 from "./asistente-widget.vue?vue&type=style&index=0&id=5106847d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5106847d",
  null
  
)

export default component.exports